<template>
  <div>
    <base-header class="pb-8 pt-4">
      <!-- Card stats -->
      <div class="row" v-if="user.homepage_permission">
        <div class="col-xl-3 col-sm-12">
          <stats-card
            title="Toplam Cari"
            :sub-title="`${pagination.totalRows} Adet`"
            icon="fas fa-chart-bar"
            class="mb-4 mb-xl-0 bg-gradient-green"
          >
          </stats-card>
        </div>

        <div class="col-xl-3 col-sm-12">
          <stats-card
            title="Toplam Borç"
            :sub-title="`${totalDebt} TL`"
            icon="fas fa-chart-pie"
            class="mb-4 mb-xl-0 bg-gradient-info"
          >
          </stats-card>
        </div>

        <div class="col-xl-3 col-sm-12">
          <stats-card
            title="Toplam Alacak"
            :sub-title="`${totalCredit} TL`"
            icon="ni ni-diamond"
            class="mb-4 mb-xl-0 bg-gradient-warning"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-sm-12">
          <stats-card
            title="Bu Ay Alacak"
            :sub-title="`${monthlyCredit} TL`"
            icon="ni ni-diamond"
            class="mb-4 mb-xl-0 bg-gradient-blue"
          >
          </stats-card>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <b-card no-body>
        <b-card-header>
          <div class="align-items-center row">
            <div
              class="col-md-6 md-block d-md-flex text-center text-md-left align-items-center mb-2 mb-md-0"
            >
              <h3 class="card-title mb-0">{{ $t('Müşteriler') }}</h3>
              <div class="text-sm ml-4">
                <b-form-group class="mb-0">
                  <b-form-input
                    placeholder="Arama kelimesi"
                    v-model="keyword"
                    debounce="500"
                  />
                </b-form-group>
              </div>
              <div class="text-sm ml-4">
                <b-form-group class="mb-0">
                  <b-form-select
                    v-model="type"
                    :options="types"
                    @change="refreshTable"
                  />
                </b-form-group>
              </div>
              <div>
                <b-button
                  @click="
                    type = undefined;
                    keyword = '';
                    $refs.table.refresh();
                  "
                  >{{ $t('Filtreleri Temizle') }}</b-button
                >
              </div>
            </div>
            <div class="col-md-6 text-right">
              <b-button :to="{ name: 'create-client' }" variant="primary"
                >+ {{ $t('Yeni Müşteri Ekle') }}</b-button
              >
            </div>
          </div>
        </b-card-header>

        <b-table
          ref="table"
          class="align-items-center"
          thead-class="thead-light"
          :fields="fields"
          :items="items"
          responsive
          show-empty
        >
          <template v-slot:table-busy>
            <div style="width: 100%; text-align: center">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>

          <template v-slot:empty>
            <b-alert variant="warning" show
              >{{
                $t(
                  'Henüz hiç müşteri eklememişsiniz, hemen yeni bir tane ekleyin'
                )
              }}!</b-alert
            >
          </template>

          <template v-slot:cell(full_name)="data">
            {{ data.item.full_name }}
            <b-badge variant="info" v-if="data.item.total_debts > 0"
              >{{ data.item.total_debts }} TL {{ $t('Alacaklı') }}</b-badge
            >
            <b-badge variant="danger" v-if="data.item.total_credits > 0"
              >{{ data.item.total_credits }} TL {{ $t('Borçlu') }}</b-badge
            >
          </template>

          <template v-slot:cell(balance)="data">
            <b-badge v-if="data.item.balance >= 0" variant="success"
              >{{ data.item.balance }} TL</b-badge
            >
            <b-badge v-else variant="danger"
              >{{ data.item.balance }} TL</b-badge
            >
          </template>

          <template v-slot:cell(actions)="data">
            <b-button
              size="sm"
              :to="{ name: 'show-client', params: { id: data.item.id } }"
              variant="outline-warning"
            >
              {{ $t('Görüntüle') }}</b-button
            >
            <b-dropdown class="action-button" right>
              <template v-slot:button-content>
                <i class="fas fa-ellipsis-v" />
              </template>
              <b-dropdown-item
                :to="{ name: 'edit-client', params: { id: data.item.id } }"
                class="dropdown-item-icon"
              >
                <i class="fas fa-pen"></i>
                <span>{{ $t('Bilgileri Güncelle') }}</span>
              </b-dropdown-item>
              <b-dropdown-item
                @click="deleteAction(data.item.id)"
                v-if="user.first_user"
                class="dropdown-item-icon"
              >
                <i class="fas fa-trash"></i>
                <span>{{ $t('Sil') }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div
          class="w-100 text-center d-flex-wrap align-items-center justify-content-center mt-2 mb-3"
        >
          <b-button
            variant="secondary"
            v-if="cPage != 1"
            @click="
              cPage = 1;
              refreshTable();
            "
            ><<</b-button
          >
          <b-button
            variant="secondary"
            v-if="cPage != 1"
            @click="
              cPage - 10 >= 1 ? (cPage = cPage - 10) : (cPage = 1);
              refreshTable();
            "
            ><
          </b-button>
          <b-button
            :variant="cPage == page ? 'primary' : 'secondary'"
            v-for="page in services.last_page"
            @click="
              cPage = page;
              refreshTable();
            "
            v-bind:key="page"
            v-if="page < cPage + 5 && page > cPage - 5"
          >
            {{ page }}
          </b-button>

          <b-button
            variant="secondary"
            v-if="cPage != services.last_page"
            @click="
              cPage + 10 <= services.last_page
                ? (cPage = cPage + 10)
                : (cPage = services.last_page);
              refreshTable();
            "
          >
            >
          </b-button>
          <b-button
            variant="secondary"
            v-if="cPage != services.last_page"
            @click="
              cPage = services.last_page;
              refreshTable();
            "
          >
            >>
          </b-button>
        </div>

        <!--        <div class="w-100 d-flex align-items-center justify-content-center mt-2 mb-3" v-if="pagination.totalRows > 14">-->
        <!--          <b-pagination v-model="pagination.currentPage" :total-rows="pagination.totalRows" :per-page="pagination.perPage" />-->
        <!--        </div>-->
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'Clients',
  data() {
    return {
      monthlyCredit: 0,
      cPage: 1,
      totalCredit: 0,
      totalDebt: 0,
      keyword: '',
      type: '',
      services: {},
      pagination: {
        currentPage: 1,
        totalRows: 1,
        perPage: 15,
      },
      types: [],
      fields: [
        { key: 'full_name', label: this.$i18n.t('Ad Soyad') },
        { key: 'gsm', label: this.$i18n.t('Telefon') },
        { key: 'contract_nos', label: this.$i18n.t('Sözleşme Numarası') },
        { key: 'company_name', label: this.$i18n.t('Firma Adı') },
        { key: 'actions', label: '', tdClass: 'text-right' },
      ],
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  mounted() {},
  methods: {
    ...mapActions(['getClients', 'deleteClient']),
    items() {
      const parameters = this.parameters();
      return this.getClients(parameters)
        .then((data) => data.data)
        .then((res) => {
          this.totalCredit = res.total_credit;
          this.totalDebt = res.total_debt;
          this.monthlyCredit = res.monthly_credit;
          this.types = res.types.filter((type) => type.text != 'Tedarikçi');

          const clients = res.clients;

          this.pagination.totalRows = clients.total;
          this.services.last_page = clients.last_page;
          return clients.data;
        });
    },
    refreshTable() {
      this.$refs.table.refresh();
    },
    parameters() {
      const params = {};
      if (this.keyword.length > 0) {
        params.keyword = this.keyword;
      }
      if (this.type) {
        params.type = this.type;
      }
      params.page = this.cPage;
      return params;
    },
    deleteAction(id) {
      this.deleteClient(id).then(() => {
        this.refreshTable();
      });
    },
  },
  watch: {
    keyword() {
      this.refreshTable();
    },
  },
};
</script>
